const styles = theme => ({
  listItemContainer: {
    background: theme.palette.primary.white,
    display: 'block',
    marginBottom: '24px',
    padding: '24px',
    border: `1px solid ${theme.palette.secondary.disableLightGray}`,
    borderRadius: '0px',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
      background: theme.palette.primary.cardHover,
    },
    '&:focus': {
      background: theme.palette.primary.cardHover,
      border: `1px solid ${theme.palette.primary.cardHoverBorder}`,
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
      marginBottom: '16px',
    },
  },
  listItemContainerChecked: {
    background: theme.palette.primary.cardHover,
    border: 'none',
  },
  listItemContainerDisabled: {
    background: '#F8F8F8',
    pointerEvents: 'none',
    opacity: '1 !important',
  },
  userInfoWrapper: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      marginLeft: '15px',
    },
  },
  userIcon: {
    width: '64px',
    height: '64px',
  },
  imgWrapper: {
    marginRight: '17px',
  },
  userType: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#484456',
    lineHeight: '21px',
    marginBottom: '4px',
    [theme.breakpoints.down('xs')]: {
      fontWeight: 500,
    },
  },
  fontW700: {
    fontWeight: '700',
  },
  listItemHeader: {
    paddingBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      gap: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '0px',
    },
  },
  listHeaderPropery: {
    [theme.breakpoints.down('sm')]: {
      padding: '0px !important',
    },
  },
  propertyPadding: {
    padding: '0px !important',
  },
  listItemTitleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      '& $chip': {
        position: 'absolute',
        right: '0',
      },
    },
  },
  listItemTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  titleText: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '21px',
    paddingBottom: '4px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0px',
    },
  },
  badgeContainer: {},
  chip: {
    display: 'inline-block',
    background: theme.palette.primary.adgmGreen,
    color: theme.palette.primary.white,
    padding: '3px 12px',
    fontWeight: 500,
    fontSize: '12px',
    borderRadius: '0px',
    whiteSpace: 'nowrap',
  },
  unitUsageContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: '8px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0',
    },
  },
  unitUsageIcon: {
    marginRight: '8px',
  },
  unitUsageText: {
    color: theme.palette.secondary.dim,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '21px',
  },
  addressContainer: {},
  addressLabel: {
    color: theme.palette.secondary.dim,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  addressData: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
  },
  summaryContainer: {
    borderTop: `1px solid ${theme.palette.primary.borderColor}`,
    paddingTop: '16px',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    columnGap: '5%',
    rowGap: '20px',
    [theme.breakpoints.down('xs')]: {
      gap: '25px',
      marginTop: '12px',
    },
  },
  summaryItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  summaryItemLabel: {
    color: theme.palette.secondary.dim,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
  },
  summaryPersonLabel: {
    color: theme.palette.secondary.dim,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '21px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  summaryItemValue: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
  },
  summaryPersonValue: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '4px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '150%',
    },
  },
  paddingBottom: {
    paddingBottom: '100px',
  },
  inputCheckbox: {
    margin: '0',
    padding: '0',

    '& > span.MuiButtonBase-root': {
      width: 'auto',
      height: 'auto',
      margin: '0',
      padding: '0',
    },

    '& > span.MuiTypography-root': {
      color: theme.palette.primary.adgmGreen,
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '21px',
      marginLeft: '6px',
    },
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
  },
  itemCheckboxIndeterminate: {
    color: '#1FCACC !important',
  },
  deleteBtn: {
    display: 'block',
    whiteSpace: 'noWrap',
    '& button': {
      color: '#DF2C2C',
      marginTop: '15px',
      textTransform: 'capitalize',
      '&:hover': {
        background: 'transparent',
      },
    },
  },
  disableInfo: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '18px',
    color: '#130F26',
    padding: '12px',
    border: '1px solid #8C9099',
    borderRadius: '0px',
    marginTop: '16px',
    '& img': {
      marginRight: '8px',
      width: '20px',
      height: '20px',
    },
  },
});

export default styles;
